import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import Arrow from "react-arrow";

import { LinearProgress } from "@mui/material";

export default function FreightVIew(props) {
  const signOff = "Customer-Signature";
  const midWay = "Midway-to-the-journey";

  const backSideUrl = props.backSideUrl;
  const frontSideUrl = props.frontSideUrl;
  const leftSideUrl = props.leftSideUrl;
  const lastLocation = props.lastLocation;
  const rightSideUrl = props.rightSideUrl;
  const ceilingUrl = props.ceilingUrl;
  const floorUrl = props.floorUrl;
  const mattressUrl = props.mattressUrl;
  const fridgeUrl = props.fridgeUrl;
  const tvUrl = props.tvUrl;

  const [backSideUrlContent, setBackSideUrlContent] = React.useState(false);
  const [frontSideUrlContent, setFrontSideUrlContent] = React.useState(false);
  const [leftSideUrlContent, setLeftSideUrlContent] = React.useState(false);
  const [rightSideUrlContent, setRightSideUrlContent] = React.useState(false);
  const [ceilingUrlContent, setceilingUrlContent] = React.useState(false);
  const [floorUrlContent, setFloorUrlContent] = React.useState(false);
  const [mattressUrlContent, setMattressUrlContent] = React.useState(false);
  const [fridgeUrlContent, setFridgeUrlContent] = React.useState(false);
  const [tvUrlContent, setTVUrlContent] = React.useState(false);
  const [
    customerSignatureUrlContent,
    setCustomerSignatureUrlContent,
  ] = React.useState(false);

  const chasis = props.chasis;
  const route = props.route;

  const stage = props.stage;
  const driver = props.driver;

  const clientPin = props.clientPin;

  const [, setHeaderBackgroundColor] = React.useState(
    stage === "enroute" ? "rgba(250,250,210,0.5)" : "rgba(220,220,210,0.5)"
  );

  const [loading, setLoading] = React.useState(false);
  const [isExpanded] = React.useState(true);

  React.useEffect(() => {
    processChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.stage]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => {
    try {
      let response = await fetch(
        "https://upcdn.io/12a1you/raw/uploads/Customer-Signature/" +
          clientPin +
          "/" +
          chasis +
          "/screenshot.png",
        {}
      );
      let details = await response.text();
      setCustomerSignatureUrlContent(details);
    } catch (e) {
      setLoading(false);
      setCustomerSignatureUrlContent(null);
      console.error("critical in yard pictures error" + JSON.stringify(e));
    }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const processChange = async () => {
    if (isExpanded && stage !== signOff) {
      setLoading(true);
      try {
        let response = await fetch(frontSideUrl, {});
        let details = await response.text();
        setFrontSideUrlContent(details);
      } catch (e) {
        setFrontSideUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(backSideUrl, {});
        let details = await response.text();
        setBackSideUrlContent(details);
      } catch (e) {
        setBackSideUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(leftSideUrl, {});
        let details = await response.text();
        setLeftSideUrlContent(details);
      } catch (e) {
        setLeftSideUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(rightSideUrl, {});
        let details = await response.text();
        setRightSideUrlContent(details);
      } catch (e) {
        setRightSideUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(ceilingUrl, {});
        let details = await response.text();
        setceilingUrlContent(details);
      } catch (e) {
        setceilingUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }
      try {
        let response = await fetch(floorUrl, {});
        let details = await response.text();
        setFloorUrlContent(details);
      } catch (e) {
        setFloorUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(mattressUrl, {});
        let details = await response.text();
        setMattressUrlContent(details);
      } catch (e) {
        setMattressUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(fridgeUrl, {});
        let details = await response.text();
        setFridgeUrlContent(details);
      } catch (e) {
        setFridgeUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }

      try {
        let response = await fetch(tvUrl, {});
        let details = await response.text();
        setTVUrlContent(details);
      } catch (e) {
        setTVUrlContent(null);
        console.error("critical in yard pictures error" + JSON.stringify(e));
      }
      setLoading(false);
    } else {
      setHeaderBackgroundColor(
        stage === "enroute" ? "rgba(250,250,210,0.5)" : "rgba(220,220,210,0.5)"
      );
    }
  };

  const handleChange = (panel) => async (event, isExpanded) => {
    processChange();
  };

  return (
    <div>
      <Accordion
        style={{ marginLeft: 3, marginTop: 20 }}
        onChange={handleChange("panel1")}
        isExpanded={isExpanded}
      >
        <AccordionSummary
          style={{
            justifyCotent: "space-between",
            backgroundColor: "#D0D4D7",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Stack alignItems="space-arround">
            <Stack
              sx={{ marginLeft: 3, marginBottom: 3 }}
              direction="row"
              spacing={1}
            >
              <Chip label={"VIN: " + chasis} color="success" />
              <span>&nbsp;</span>
              {props.driver && (
                <Chip label={"Driver: " + driver} color="primary" />
              )}
              <span>&nbsp;</span>
              <Chip label={"Stage: " + stage} color="warning" />
              &nbsp; &nbsp; &nbsp; &nbsp;
              <Chip label={route.split("to")[0]} color="default" />
              <Arrow
                direction="right"
                shaftWidth={10}
                shaftLength={20}
                headWidth={30}
                headLength={15}
                fill="transparent"
                stroke="orange"
                strokeWidth={2}
              />
              <Chip label={route.split("to")[1]} color="info" />
            </Stack>

          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          {loading && <LinearProgress></LinearProgress>}
          {stage !== signOff && stage !== midWay ? (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-between",
                maxWidth: "100vw",
              }}
            >
              {frontSideUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.frontSideDate}</p>
                  <p>{props.frontSideLocation}</p>
                  <p> Front Side</p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={frontSideUrlContent}
                  />
                </span>
              )}
              {backSideUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.backSideDate}</p>
                  <p>{props.backSideLocation}</p>
                  <p> Back Side</p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={backSideUrlContent}
                  />
                </span>
              )}

              {leftSideUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.leftSideDate}</p>
                  <p>{props.leftSideLocation}</p>
                  <p> Left Side</p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={leftSideUrlContent}
                  />
                </span>
              )}

              {rightSideUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.rightSideDate}</p>
                  <p>{props.rightSideLocation}</p>
                  <p> Right Side</p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={rightSideUrlContent}
                  />
                </span>
              )}

              {ceilingUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.ceilingDate}</p>
                  <p>{props.ceilingLocation}</p>
                  <p> Ceiling </p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={ceilingUrlContent}
                  />
                </span>
              )}

              {mattressUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.mattressDate}</p>
                  <p> Mattress</p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={mattressUrlContent}
                  />
                </span>
              )}

              {tvUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.tvDate}</p>
                  <p>{props.tvLocation}</p>
                  <p> TV </p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={tvUrlContent}
                  />
                </span>
              )}

              {floorUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.floorDate}</p>
                  <p>{props.floorLocation}</p>
                  <p> Floor </p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={floorUrlContent}
                  />
                </span>
              )}
              {fridgeUrl && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p>{props.fridgeDate}</p>
                  <p>{props.fridgeLocation}</p>
                  <p> Fridge </p>
                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={fridgeUrlContent}
                  />
                </span>
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-between",
                maxWidth: "100vw",
              }}
            >
              {customerSignatureUrlContent && stage === signOff && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <p> Signature</p>

                  <img
                    alt=""
                    style={{ height: 320, width: 480 }}
                    src={customerSignatureUrlContent}
                  />
                </span>
              )}

              {stage === midWay && (
                <span
                  style={{
                    flexDirection: "column",
                    flexBasis: "20%",
                    border: "1px #ccc solid",
                  }}
                >
                  <Stack>
                    <Chip
                      label={"Driver last reported location " + lastLocation}
                      color="default"
                    />
                  </Stack>
                </span>
              )}
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
